export const PDF_VIEWER_BUFFER_PAGES = 1